"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContainerComponent;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ContainerComponent(_ref) {
  var {
    children,
    containerStyles
  } = _ref;
  var styles = {
    minW: '18.75rem',
    maxW: {
      base: 'none',
      mobile: '100%',
      sm: '100%',
      md: '100%',
      lg: 'var(--chakra-space-breakpoint-lg)',
      xl: 'var(--chakra-space-breakpoint-xl)'
    },
    px: {
      base: 0,
      mobile: '1rem',
      sm: '1.125rem',
      md: '1.5rem',
      lg: '1.75rem',
      xl: '4.125rem'
    }
  };
  return (0, _jsxRuntime.jsx)(_react.Container, _objectSpread(_objectSpread(_objectSpread({}, styles), containerStyles), {}, {
    children: children
  }));
}